import FileWithContext from '../../models/file_with_context'
import InvalidEnum from '../invalid_enum'

class InvalidInvoiceType extends InvalidEnum {
  constructor(value) {
    super(value, 'invoice_type', Object.values(FileWithContext.INVOICE_TYPE))
  }
}

export default InvalidInvoiceType
